import { IconEyeOff, IconPhoto } from '@tabler/icons-react';
import { IconButton, Stack, Text, WP_ICON_NAV } from '@wapharma/design-system';
import { useCatalogImageResolveInboxContextOptional } from '../contexts/CatalogImageResolveInboxContext';
import { InboxDrillableHint } from './InboxDrillableHint';
import { ImportJobStatusDot } from './ImportJobStatusDot';
import styles from './InboxBulkImportItems.module.css';

export function InboxImageResolveQueueItems({
  onOpenQueue,
  isQueueSeen,
  onMarkQueueSeen,
}: {
  onOpenQueue?: () => void;
  isQueueSeen?: () => boolean;
  onMarkQueueSeen?: () => void | Promise<void>;
}) {
  const inbox = useCatalogImageResolveInboxContextOptional();
  if (!inbox?.showQueueCard) return null;

  const unread = isQueueSeen ? !isQueueSeen() : true;
  const { queueActionCount, queueStats } = inbox;

  const open = onOpenQueue
    ? () => {
        void onMarkQueueSeen?.();
        onOpenQueue();
      }
    : undefined;

  return (
    <Stack gap="xs" className={styles.list} aria-label="Images catalogue à traiter">
      <article
        className={`${styles.card} ${unread ? styles.cardUnread : styles.cardRead}`}
        data-inbox-drillable={open ? '' : undefined}
        role={open ? 'button' : undefined}
        tabIndex={open ? 0 : undefined}
        onClick={open}
        onKeyDown={
          open
            ? (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  open();
                }
              }
            : undefined
        }
        style={open ? { cursor: 'pointer' } : undefined}
      >
        <div className={styles.cardHead}>
          <ImportJobStatusDot status="COMPLETED" size={12} className={styles.cardStatus} />
          <div className={styles.cardTitles}>
            <Text size="sm" fw={unread ? 600 : 500} style={{ lineHeight: 1.35 }}>
              Images à traiter
            </Text>
            <Text size="xs" c="dimmed" style={{ marginTop: 4 }}>
              {queueActionCount.toLocaleString('fr-FR')} produit(s) — {queueStats?.review ?? 0} à valider,{' '}
              {queueStats?.pending ?? 0} en attente, {queueStats?.failed ?? 0} échouées
            </Text>
          </div>
          <div className={styles.cardActionsInline}>
            {open ? <InboxDrillableHint /> : null}
            <IconPhoto size={16} stroke={1.5} aria-hidden style={{ color: 'var(--wp-text-muted)' }} />
            <IconButton
              type="button"
              size="xs"
              variant="ghost"
              aria-label="Masquer"
              title="Masquer — réapparaît si la file change"
              onClick={(e) => {
                e.stopPropagation();
                void onMarkQueueSeen?.();
                inbox.dismissQueueCard();
              }}
            >
              <IconEyeOff {...WP_ICON_NAV} />
            </IconButton>
          </div>
        </div>
      </article>
    </Stack>
  );
}
